import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

import {AuthModule} from '@intocare/auth';

import {DashboardComponent} from './containers/dashboard/dashboard.component';
import {routes} from './dashboard.routing';
import {DashboardModel} from './model/dashboard.model';
import {CallSignalOverviewModule} from '../cards/statistics/call-signal-overview/call-signal-overview.module';
import {ResidentOverviewModule} from '../cards/statistics/resident-overview/resident-overview.module';
import {TaskOverviewModule} from '../cards/statistics/task-overview/task-overview.module';
import {CoreModule} from '../core';

@NgModule({
	imports: [
		CoreModule,
		RouterModule.forChild(routes),
		AuthModule,
		TaskOverviewModule,
		ResidentOverviewModule,
		CallSignalOverviewModule
	],
	declarations: [DashboardComponent],
	providers: [DashboardModel]
})
export class DashboardModule {}
